import { RentACarReview } from "@/components/common/reviewsBlock/ReviewsBlock";
import { NextSchedule } from "./disponibility";

type CommunicationMeans = {
  email: string | null;
  mobilePhone: string | null;
  phone: string | null;
  phoneH24: string | null;
};

type City = {
  name: string;
  slug: string;
};

type State = {
  name: string;
  slug: string;
};

export type Address = {
  city: string | null;
  complementaryStreet: string | null;
  country: string | null;
  latitude: number;
  longitude: number;
  street: string | null;
  zipCode: string | null;
};

export enum Activity {
  ROUND_TRIP = "Roundtrip",
  ONE_WAY = "Oneway",
  WITHOUT_LICENCE = "RoundtripWithoutLicense",
}

export type ProximityAgency = {
  distance: number;
  id: string;
  name: string;
  rank: number;
  slug: string;
};

export type AgencyDetails = {
  id: string;
  slug: string;
  label: string;
  city: City;
  state: State;
  communicationMeansDto: CommunicationMeans;
  addressDto: Address;
  activities: Activity[];
  accessibilityInfo: string | null;
  agenciesByProximity: ProximityAgency[];
  nextSchedules: NextSchedule[];
  reviews?: RentACarReview;
};
